import request from '@/utils/request'

let RouteApi = {

  /*路线列表*/
  list(data) {
    return request._post('/shop/plus.route.Index/index', data);
},
/*添加路线*/
add(data) {
    return request._post('/shop/plus.route.Index/add', data);
},
recommend(data){
     return request._post('/shop/plus.route.Index/recommend', data);
},
/*修改路线*/
edit(data) {
    return request._post('/shop/plus.route.Index/edit', data);
},
editx(data) {
    return request._post('/shop/plus.route.Index/editx', data);
},
/*删除路线*/
del(data) {
    return request._post('/shop/plus.route.Index/del', data);
},
/*复制路线*/
copy(data) {
    return request._post('/shop/plus.route.Index/copy', data);
},
/*隐藏 / 显示路线*/
hide(data) {
    return request._post('/shop/plus.route.Index/hide', data);
  },
  categoryOptions(data) {
    return request._post('/shop/plus.route_category.Index/options', data);
  },
  provinceOptions(data) {
    return request._post('/shop/setting.region/provinceOptions', data);
  },

/*路线详情*/
detail(data) {
  return request._post('/shop/plus.route.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.route.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.route.Setting/getSetting', data, errorback);
    },



      /*获取路线报名尽量*/
  signlist(data) {
    return request._post('/shop/plus.route.Sign/index', data);
},

signPersonList(data) {
    return request._post('/shop/plus.route.SignPerson/index', data);
},

}
export default RouteApi;



// WEBPACK FOOTER //
// ./src/api/route.js